module.exports = __webpack_public_path__ + "media/packs/images/flags/MW-a0f42adfe6df4f5dd9feda0ddec2d1dc.png";